import type { ChangeType, EntityConfig } from "./versionDiff.types";

export const ENTITY_CONFIG: Record<string, EntityConfig> = {
  abtest: {
    sectionKey: "abTestChanges",
    selectedKey: "selectedAbTests",
    label: "A/B Tests",
    icon: "split",
    color: "#1d4ed8",
    bgColor: "#dbeafe",
  },
  configuration: {
    sectionKey: "configRuleGroupChanges",
    selectedKey: "selectedConfigRuleGroups",
    label: "Remote Configs",
    icon: "sliders",
    color: "#047857",
    bgColor: "#d1fae5",
  },
  class: {
    sectionKey: "classChanges",
    selectedKey: "selectedClasses",
    label: "Classes",
    icon: "rectangle-code",
    color: "#047857",
    bgColor: "#d1fae5",
  },
  offer: {
    sectionKey: "offerChanges",
    selectedKey: "selectedOffers",
    label: "Offers",
    icon: "tags",
    color: "#c2410c",
    bgColor: "#ffedd5",
  },
  campaign: {
    sectionKey: "campaignChanges",
    selectedKey: "selectedCampaigns",
    label: "Campaigns",
    icon: "bullhorn",
    color: "#c2410c",
    bgColor: "#ffedd5",
  },
  shop: {
    sectionKey: "shopChanges",
    selectedKey: "selectedShops",
    label: "Shops",
    icon: "store",
    color: "#c2410c",
    bgColor: "#ffedd5",
  },
  reward: {
    sectionKey: "rewardChanges",
    selectedKey: "selectedRewards",
    label: "Rewards",
    icon: "gift",
    color: "#c2410c",
    bgColor: "#ffedd5",
  },
  item: {
    sectionKey: "itemChanges",
    selectedKey: "selectedItems",
    label: "Items",
    icon: "box",
    color: "#c2410c",
    bgColor: "#ffedd5",
  },
  segment: {
    sectionKey: "segmentChanges",
    selectedKey: "selectedSegments",
    label: "Segments",
    icon: "bullseye-arrow",
    color: "#6d28d9",
    bgColor: "#ede9fe",
  },
  metric: {
    sectionKey: "metricChanges",
    selectedKey: "selectedMetrics",
    label: "Metrics",
    icon: "key-skeleton-left-right",
    color: "#6d28d9",
    bgColor: "#ede9fe",
  },
};

export const CHANGE_TYPE_CONFIG: Record<ChangeType, { icon: string; label: string }> = {
  ADDED: { icon: "star", label: "Created" },
  UPDATED: { icon: "pencil", label: "Updated" },
  REMOVED: { icon: "xmark", label: "Removed" },
  PUBLISHED: { icon: "stamp", label: "Published" },
  STOPPED: { icon: "hand", label: "Stopped" },
  ARCHIVED: { icon: "archive", label: "Archived" },
};
